
const enum ContractType {
    'Standard',
    'None'

};
import { Salesunit } from '../salesunit';
import { Contact } from '../contact';
import { Contract } from '../contract';
export class Booth {
    constructor(
        public id?: number,
        public contractType?: ContractType,
        public order?: number,
        public salesunit?: Salesunit,
        public contactPerson?: Contact,
        public contract?: Contract,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/booth/booth.model.ts